const config = {
  config: [
    {
      baseUrl: "http://198.251.70.43:8080/"
    }
  ]
};

export default config;
